import '../css/homepage-en-us.scss';
import Modernizr from 'modernizr';
import $ from '@modules/jquery-import';
import mediaQuery from '@util/media-queries';
import {jqueryValidate, jquerySmartResize, Corpus} from '@modules/lazy-imports';

$( function () {

    var $sales = $( '#body-content' ),
        defaults = ['navigation-style:progressive'],
        bp = mediaQuery.getCurrentBreakPoint(),
        promos = $sales.find( '.carousel' );

    initCarousel( $sales, defaults );

    jquerySmartResize().then( () => {
        $( window ).smartresize( function () {
            var curBreakPoint = mediaQuery.getCurrentBreakPoint();
            if ( curBreakPoint !== bp ) {
                initCarousel( $sales, defaults );
                bp = curBreakPoint;
            }
        } );
    } );

    async function initCarousel ( scope, options ) {
        await Corpus();

        var opts = options.slice.apply( options );

        scope.corpus( 'off' );

        if ( Modernizr.mq( mediaQuery.min.screenBase ) || !Modernizr.mq( 'only all' ) ) {
            opts.push( 'multiplier:4' );
        }
        else if ( Modernizr.mq( mediaQuery.min.screenMedium ) ) {
            opts.push( 'multiplier:3' );
        }
        else if ( Modernizr.mq( mediaQuery.min.screenSmall ) ) {
            opts.push( 'multiplier:2' );
        }
        else {
            opts.push( 'multiplier:1' );
        }
        // apply declarative settings

        promos.data( 'options', opts.join( ',' ).toString() );
        scope.corpus( 'carousel' );
    }
} );
